// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yboox","label":"styles_label__ShnsA"};